'use strict'
import api from '@/api/api'
import notify from "@/utils/notify"
import router from "@/router";

export default {
  async createCustomer(json) {
    const data = {
      method: 'post',
      url: 'customer',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 201) {
      notify.alert.success('Customer created successfully')
      await router.push('/customer/' + response.data.id)
    }
  },

  async getCustomers(params = {}) {
    const query = new URLSearchParams()
    if (params.page) query.set('page', params.page)
    if (params.per_page) query.set('per_page', params.per_page)
    if (params.search) query.set('search', params.search)

    const data = {
      method: 'get',
      url: `customers${query.toString() ? `?${query.toString()}` : ''}`,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },

  async getCustomer(id) {
    const data = {
      method: 'get',
      url: 'customer/' + id,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },

  async updateCustomer(json, id) {
    const data = {
      method: 'put',
      url: 'customer/' + id,
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Customer updated successfully')
      await router.push('/customer/' + response.data.id)
    }
  },
}
